import { WHITE_COLORS } from '../constants';
export const getShadeBorder = (background, theme) => WHITE_COLORS.includes(background) ? `1px solid ${theme.palette.grey[200]}` : undefined;
//# sourceMappingURL=getShadeBorder.js.map